import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import { BaseSelectProps } from '../types/global';
import { FormHelperText } from '@mui/material';
import ElementDescription from './ElementDescription';
import { checkFeatureFieldEnabled } from '../helpers/configuration';

function getStyles(name: string, activeName: string, theme: Theme) {
  return {
    fontWeight:
      activeName === name
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
  };
}

const BaseSelect = ({
  label,
  values,
  onChange,
  value,
  name,
  isDisabled,
  errors,
  required,
  description,
  feature = null,
}: BaseSelectProps) => {
  const theme = useTheme();

  const selectId = `${name}-select`;
  const labelId = `${name}-select-label`;

  if (name && feature && !checkFeatureFieldEnabled(feature, name)) {
    return null;
  }

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId} required={required || false}>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        id={selectId}
        value={value}
        label={label}
        name={name}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        error={!!errors?.[name]}
        required={required || false}
        disabled={isDisabled || false}
      >
        {values.map((value) => (
          <MenuItem
            key={value}
            value={value}
            style={getStyles(value, value, theme)}
          >
            {value === '' ? ' ' : value}
          </MenuItem>
        ))}
      </Select>
      {!!errors?.[name] ? (
        <FormHelperText sx={{ marginLeft: 0 }} error={true}>
          {errors?.[name]}
        </FormHelperText>
      ) : null}
      {description ? (
        <ElementDescription>{description}</ElementDescription>
      ) : null}
    </FormControl>
  );
};

export default BaseSelect;
